const onUpdate = ( status ) => {

    switch ( status ) {
        case 404:
            return {
                status: status,
                message: "aggiornare la commessa: la commessa non esiste",
                redirectRoute: '/commesse/'
            }    
        case 422:
            return {
                status: status,
                message: "aggiornare la commessa: errore nei parametri di richiesta",
            } 
        default:
            return null;
    }

}

export default onUpdate;